import globalMessage from "@/utils/globalMessage";
import React from "react";
import axios from "axios";

import { Modal, Typography } from "antd";
import { store } from "@redux/store";
import authActions from "@redux/auth/actions";
import sessionManager from "@/services/sessionManager";
import { unregisterSessionAbort } from "@/services/requestLifecycle";
import { ENV } from "@config/env";
import _ from "lodash";

const { backendUrl } = ENV;

export const companyRequest = axios.create({
    baseURL: backendUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

companyRequest.interceptors.request.use(
    (config) => {
        const session = sessionManager.getSessionSnapshot();
        if (session.sessionResetting) {
            return Promise.reject(new Error("Session is resetting"));
        }
        const controller = new AbortController();
        config.signal = config.signal || controller.signal;
        config.__unregisterSessionAbort = sessionManager.registerRequestController(controller);
        if (session.access) {
            config.headers["Authorization"] = "Bearer " + session.access;
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

//response interceptor to refresh token on receiving token expired
companyRequest.interceptors.response.use(
    (response) => {
        unregisterSessionAbort(response.config);
        // if (response.config.method !== 'get' && !response.config.url.includes('log') && !response.config.url.includes('token/refresh')) {
        //
        //     // api.createLog({
        //     //     status: response.status,
        //     //     type: response.config.method,
        //     //     message: typeof response.config.data === 'string' ? response.config.data : '{}',
        //     //     params: JSON.stringify(response.config.params),
        //     //     url: response.config.url,
        //     //     company: store.getState().Facility.selected.record?.company_id
        //     // })
        // }
        return response;
    },
    function (error) {
        unregisterSessionAbort(error.config);
        // console.log('axios error: ', error.response)
        if (!error.response) {
            return null;
        }
        const originalRequest = error.config;
        const session = sessionManager.getSessionSnapshot();
        let refresh = session.refresh;
        if (
            error.response?.status === 401 &&
            originalRequest.url === backendUrl + `/auth/token/refresh`
        ) {
            // console.log('error', error.response.data)
            // notification['error']({
            //     message: error.response.data.code,
            //     description:  error.response.data.detail
            // });
            if (error.response.data.code === "token_not_valid") {
                sessionManager.reset({ reason: "unauthorized" });
            }
            return Promise.reject(error);
        } else if (
            refresh &&
            error.response?.status === 401 &&
            !originalRequest._retry &&
            !session.sessionResetting
        ) {
            originalRequest._retry = true;
            return axios
                .post(backendUrl + `/auth/token/refresh`, { refresh: refresh })
                .then((res) => {
                    store.dispatch(authActions.updateToken(
                        res.data.access,
                        res.data.refresh || refresh,
                        res.data.access_token_expiration || res.data.accessTokenExpiration || session.accessTokenExpiration,
                        res.data.refresh_token_expiration || res.data.refreshTokenExpiration || session.refreshTokenExpiration
                    ));
                    axios.defaults.headers.common["Authorization"] =
                        "Bearer " + res.data.access;
                    originalRequest.headers = {
                        ...originalRequest.headers,
                        Authorization: "Bearer " + res.data.access,
                    };

                    return axios(originalRequest);
                })
                .catch((refreshError) => {
                    sessionManager.reset({ reason: "unauthorized" });
                    return Promise.reject(refreshError);
                });
        } else if (error.response?.status === 401) {
            sessionManager.reset({ reason: "unauthorized" });
            return Promise.reject(error);
        } else if (error.response?.status === 400 || error.response?.status > 401) {
            console.log("error.response.data", error.response.data);
            let error_data = error.response.data;
            let error_data_response = [];

            if (
                typeof error_data !== "object" &&
                error.response.data?.startsWith("<!DOCTYPE html>")
            ) {
                error_data_response = "Server Error";
                globalMessage["error"]({
                    message: error.response.statusText,
                    description: error_data_response.toString(),
                });
            } else if (typeof error_data === "object") {
                let error_messages = [];

                Object.keys(error_data).forEach((key) => {
                    if (error_data[key]?.[0] === "This field must be unique.") {
                        error_messages.push(`${key} already exists.`);
                    } else {
                        globalMessage["error"]({
                            message: error.response.statusText,
                            description: JSON.stringify(error_data[key]),
                        });
                    }
                });

                if (error_messages.length > 0) {
                    Modal.info({
                        title: (
                            <Typography.Title level={4}>
                                Duplicated Field Detected!
                            </Typography.Title>
                        ),
                        wrapClassName: "antd-modal-foot-center",
                        content: (
                            <div>
                                {error_messages.map((message, index) => (
                                    <p key={index}>{message}</p>
                                ))}
                            </div>
                        ),
                        onOk() { },
                    });
                }
            } else if (error.response?.status === 403) {
                globalMessage["error"]({
                    message: 'Forbidden',
                    description: 'You are not authorized to access this resource',
                });
                return
            } else {
                error_data_response = error_data;
                globalMessage["error"]({
                    message: error.response.statusText,
                    description: error_data_response.toString(),
                });
            }

            if (_.get(error.response, "data.detail") === "User has no permission.") {
                window.location.href = "/Dashboard";
                window.alert(_.get(error.response, "data.detail"));
            }
        }

        return Promise.reject(error);
    }
);
